module.exports = __webpack_public_path__ + "media/hyper/fonts/Nunito-Light-520926ed257d63d3f5f0090730219a40.woff2";